import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './UserManager.css';
import backIcon from '../../assets/backspace-icon.png';

function UserManager() {
  const [users, setUsers] = useState([]);
  const [roleFilter, setRoleFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchUsers();
  }, [roleFilter]);


// 🔁 Auto-refresh user list every 30 seconds
useEffect(() => {
  const interval = setInterval(() => {
    fetchUsers();
  }, 30000); // 30,000ms = 30 seconds

  return () => clearInterval(interval);
}, []);



  const fetchUsers = async () => {
    try {
      const res = await api.get('/admin/users');
      let filtered = res.data;

      // ✅ Apply role/suspension filters
      if (roleFilter === 'suspended') {
        filtered = filtered.filter(user => user.status === 'suspended');
      } else if (roleFilter !== 'all') {
        filtered = filtered.filter(user => user.userType === roleFilter);
      }

      // ✅ Sort by most recent activity or fallback to createdAt
      filtered.sort((a, b) => {
        const aTime = new Date(a.lastActiveAt || a.createdAt).getTime();
        const bTime = new Date(b.lastActiveAt || b.createdAt).getTime();
        return bTime - aTime;
      });

      setUsers(filtered);
    } catch (err) {
      console.error('Failed to fetch users', err);
    }
  };


const formatLastActive = (dateString) => {
  if (!dateString) return 'Never';

  const date = new Date(dateString);
  const now = new Date();
  const diff = now - date;

  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / (60 * 1000));
  const hours = Math.floor(diff / (60 * 60 * 1000));
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30);

  if (seconds < 60) return 'Just now';
  if (minutes < 60) return `${minutes} minute${minutes !== 1 ? 's' : ''} ago`;
  if (hours < 24) return `${hours} hour${hours !== 1 ? 's' : ''} ago`;
  if (days === 1) return 'Yesterday';
  if (days < 7) return `${days} day${days !== 1 ? 's' : ''} ago`;
  if (weeks < 5) return `${weeks} week${weeks !== 1 ? 's' : ''} ago`;
  return `${months} month${months !== 1 ? 's' : ''} ago`;
};



  const filteredUsers = users.filter(user => {
    const fullText = `${user.username} ${user.name} ${user.businessUsername || ''}`.toLowerCase();
    return fullText.includes(searchTerm.toLowerCase());
  });

  return (
    <div className="user-manager-container">
      <div className="user-manager-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="back-arrow"
          onClick={() => navigate('/admin')}
        />
        <span className="user-manager-topbar-title">User Manager</span>
      </div>

      <div className="user-manager-scroll-area">
        <div className="user-manager-role-filter">
          {['all', 'pioneer', 'merchant', 'admin', 'suspended'].map((role) => (
            <button
              key={role}
              className={roleFilter === role ? 'active' : ''}
              onClick={() => setRoleFilter(role)}
            >
              {role === 'suspended' ? 'Suspended' : role.charAt(0).toUpperCase() + role.slice(1)}
            </button>
          ))}
        </div>

        <div className="user-manager-search-box">
          <input
            type="text"
            placeholder="Search by name or username"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div className="user-manager-list">
          {filteredUsers.map((user) => {
            const lastActiveRaw = user.lastActiveAt;
            const isToday = lastActiveRaw && new Date().toDateString() === new Date(lastActiveRaw).toDateString();

            return (
              <div
                className="user-card"
                key={user._id}
                onClick={() => navigate(`/admin/users/${user._id}`)}
              >
                <div className="user-card-header">
                  <strong>{user.name}</strong>
                  <div className="username">
                    @{user.userType === 'merchant' && user.businessUsername
                      ? user.businessUsername
                      : user.username}
                  </div>
                </div>

                <div className="user-meta-line">
                  <span className="badge role">{user.userType}</span>
                  {user.userType === 'merchant' && user.status && (
                    <span className={`badge status ${user.status}`}>{user.status}</span>
                  )}
                </div>


<div className="joined-date">
  Joined: {new Date(user.createdAt).toLocaleDateString()}
</div>

<div className={`last-active ${isToday ? 'today' : ''}`}>
  Last Seen: {formatLastActive(user.lastActiveAt)}
</div>



              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default UserManager;
